<template lang="pug">
  img(
    :src="src"
    :alt="name"
    :srcset="srcset"
    align="top"
    :class="['icon', name]"
    @click="$emit('click')"
  )
</template>

<script>
export default {
  props: {
    name: { type: String, required: true },
  },
  computed: {
    src() {
      return require(`@/assets/icons/${this.name}.png`)
    },
    srcset() {
      return (
        require(`@/assets/icons/${this.name}.png`) +
        ' 1x, ' +
        require(`@/assets/icons/${this.name}@2x.png`) +
        ' 2x, ' +
        require(`@/assets/icons/${this.name}@3x.png`) +
        ' 3x'
      )
    },
  },
}
</script>
